import { scaleQuantile, ScaleQuantile } from 'd3-scale';
import chunk from 'lodash.chunk';

import { Quartile } from '../../types/graphs';
import { CircleProps, RectProps } from '../../types/svg';

export const shapesMaxingEdge: (
  edgeToMax: number,
  otherEdge: number,
  shapeCount: number,
) => number = (edgeToMax, otherEdge, shapeCount) => {
  const idealArea = edgeToMax * otherEdge / shapeCount;
  const idealEdgeLength = Math.sqrt(idealArea);
  const idealCountAlongEdge = edgeToMax / idealEdgeLength;

  return Math.ceil(idealCountAlongEdge);
};

export const edgeLengthMaxingEdge: (
  edgeToMax: number,
  otherEdge: number,
  shapeCount: number,
) => number = (edgeToMax, otherEdge, shapeCount) => {
  const shapesAlongEdge = shapesMaxingEdge(edgeToMax, otherEdge, shapeCount);
  const shapesAlongOtherEdge = Math.floor(
    shapesAlongEdge * otherEdge / edgeToMax,
  );
  const edgeLength = edgeToMax / shapesAlongEdge;
  const willFit = shapesAlongEdge * shapesAlongOtherEdge >= shapeCount;
  const edgeLengthFittingOtherEdge =
    otherEdge / Math.ceil(otherEdge / edgeLength);

  return willFit ? edgeLength : edgeLengthFittingOtherEdge;
};

export const maxPackingEdge: (
  containingHeight: number,
  containingWidth: number,
  shapeCount: number,
) => number = (height, width, count) => {
  const edgeLengthMaxingHeight = edgeLengthMaxingEdge(height, width, count);
  const edgeLengthMaxingWidth = edgeLengthMaxingEdge(width, height, count);

  return Math.max(edgeLengthMaxingHeight, edgeLengthMaxingWidth);
};

export const circleFromSquare: (square: RectProps) => CircleProps = square => {
  const radius = square.height / 2;

  return {
    cx: square.x + radius,
    cy: square.y + radius,
    r: radius,
  };
};

export const scoreToQuartileScale = scaleQuantile<Quartile>()
  .domain([0, 100])
  .range([0, 1, 2, 3]);

export type QuartilesFn = <T>(array: T[]) => Quartiles<T>;
export type QuartilesBase<T> = [T[], T[], T[], T[]];

export interface Quartiles<T> extends QuartilesBase<T> {
  memberLength: number;
}

export const quartiles: QuartilesFn = array => {
  const memberLength = array.length / 4;

  const _quartiles = chunk(array, memberLength);
  _quartiles.memberLength = memberLength;

  return _quartiles;
};

export const padding: (paddings: number[]) => number[] = pads => {
  if (pads.length === 4) {
    return pads;
  } else if (pads.length === 3) {
    return [pads[0], pads[1], pads[2], pads[1]];
  } else if (pads.length === 2) {
    return [pads[0], pads[1], pads[0], pads[1]];
  } else {
    return [pads[0], pads[0], pads[0], pads[0]];
  }
};
